import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import Table from "../../../../../../common/components/table-manager/v1.1/table";
import _ from "lodash";
import PageLoader from "../../../../../../components/PageLoader";
import {orderData} from '../settlement-request-items'

import { SettlementRequestItemPopup } from "../components/settlement-request-item-popup.component";
import { updateNestedValue } from "../../../../../../common/services/common.service";
import { selectSettlementRequestItemCreatedItem, selectSettlementRequestItemDeletedItem, selectSettlementRequestItemsListItems, selectSettlementRequestItemUpdatedItem } from "../../../../../../redux/settlement-hub/settlement-request-items/selector";
import { settlementRequestItems } from "../../../../../../redux/settlement-hub/settlement-request-items/action";
import { libraryData, BUYER_APP, TO_BE_INITIATED } from "../../constants/constants";

const SettlementRequestItems = ({
  selectedSettlementRequest
}: any) => {

  const dispatch = useAppDispatch()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const [showSettlementItemPopup, setShowSettlementItemPopup] = useState<boolean>(false);
  const [selectedSettlementRequestItem, setSelectedSettlementRequestItem] = useState<any>({
    "SettlementRequestId": 0,
    "SettlementRequestItemStatusId": TO_BE_INITIATED,
    "OrderId": "",
    "ParticipantId": "",
    "ParticipantRoleId": BUYER_APP,
    "ReferenceNo": "",
    "SettlementFor": "",
    "Amount": {
      "Currency": "INR",
      "Value": ""
    }
  });
  // const [selectedParticipant, setSelectedParticipant] = useState<any>({
  //   "SettlementRequestId": 0,
  //   "SettlementRequestItemStatusId": TO_BE_INITIATED,
  //   "OrderId": "",
  //   "ParticipantId": "",
  //   "ParticipantRoleId": BUYER_APP,
  //   "ReferenceNo": "",
  //   "Amount": {
  //     "currency": "INR",
  //     "value": ""
  //   }
  // });

  const [listItems, setListItems] = useState<any>([]);
  const listOfSettlementRequestItemsData = useSelector(selectSettlementRequestItemsListItems)
  const createSettlementRequestItemsData = useSelector(selectSettlementRequestItemCreatedItem)
  const editSettlementRequestItemsData = useSelector(selectSettlementRequestItemUpdatedItem)
  const deleteSettlementsRequestItemData = useSelector(selectSettlementRequestItemDeletedItem)
  const [columnDefs, setColumnDefs] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'OrderId', headerName: 'Order Id', sortable: true, filter: true, filterType: 'text',  },
      { field: 'ParticipantId', headerName: 'Participant', sortable: true, filter: true, filterType: 'text',  },
      { field: 'ReferenceNo', headerName: 'Reference No', sortable: true, filter: true, filterType: 'text',  },
      { field: 'SettlementFor', headerName: 'Settlement For', sortable: true, filter: true, filterType: 'text',  },
      { field: 'Amount.Value', headerName: 'Amount', sortable: true, filter: true, filterType: 'number',  },
      { field: 'SettlementRequestItemStatusId', headerName: 'Status', sortable: true, filter: true, filterType: 'text', cellRenderer: 'libraryRendererComponent',
        cellRendererParams: { library: libraryData, menuKey: 'Value', menuValue: 'Description', callback: handleStatus, anchorPosition: 'top-left' },
      },
      {field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true, sortable: true, filter: true, filterType: 'date',},
      {field: 'UpdatedOnUtc', headerName: 'Updated On', isDateValueFormat: true, sortable: true, filter: true, filterType: 'date',},

    ]);
  }

  const handleStatus = () => {

  }

  const handleInnerFormChange: any = ({path, value}: any) => {
    console.log('selectedParticipant, path, value', selectedSettlementRequestItem, path, value)
    const updatedData = updateNestedValue(selectedSettlementRequestItem, path, value)

    console.log('updatedData', updatedData)
    setSelectedSettlementRequestItem({...updatedData});
  }

  const handleAdd = () => {   
    const participant = {
      "SettlementRequestId": 0,
      "SettlementRequestItemStatusId": TO_BE_INITIATED,
      "OrderId": "",
      "ParticipantId": "",
      "ParticipantRoleId": BUYER_APP,
      "ReferenceNo": "",
      "SettlementFor": "",
      "Amount": {
        "Currency": "INR",
        "Value": ""
      }
    } 
    // setSelectedParticipant(participant)
    setSelectedSettlementRequestItem({...participant})
    setShowSettlementItemPopup(true)
  }

  const handleEdit = (data: any) => {
    // setSelectedParticipant(data)
    setSelectedSettlementRequestItem(data)
    setShowSettlementItemPopup(true)
  }

  const handleDelete = async (data: any) => {
    console.log('delete item', data)
    // const ids = _.map(data, (item: any) => {return {Id: item?.SettlementRequest?.Id}})
    // console.log('ids',ids)
    await dispatch(settlementRequestItems.delete({
      url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/settlement-hub/settlement-request-items/delete`,
      entity: 'settlementRequestItems',
      jsonData: {
        Context:{},
        Records: [{Id: data?.SettlementRequest?.Id}]
      }
    }));
  }

  const additionButtons: any = [
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
          <title>Add Settlement</title>
          <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
        </svg>,
      // name: 'Initiate Settlement',
      callback: () => handleAdd(),
    },
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload this table</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      // name: 'Reload',
      callback: () => handleReloadData(),
    },
  ];

  const handleReloadData = () => {
    listSettlementRequestItems();
  }


  const listSettlementRequestItems = async () => {
    console.log('settlementRequestItems')
    await dispatch(settlementRequestItems.resetAction({actionType:'list'}))
    await dispatch(settlementRequestItems.list({
      url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/settlement-hub/settlement-request-items/list`,
      entity: 'settlementRequestItems',
      jsonData: {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
      }
    }))
  }

  const handleSaveSettlementRequestItem = async (selectedSettlementRequestItem: any) => {
    console.log('selectedSettlementRequestItem', selectedSettlementRequestItem)
    // const selectedSettlementRequestItem = {
    //   SettlementId: selectedSettlementRequest?.SettlementId,
    //   order: {
    //     id: selectedSettlementRequest?.order?.id,
    //     participants: [
    //       ...selectedParticipant
    //     ]
    //   }     
    // }
    setSelectedSettlementRequestItem(selectedSettlementRequestItem)
    console.log('selectedSettlementRequestItem', selectedSettlementRequestItem)
    if (selectedSettlementRequestItem?.Id > 0) {      
      await dispatch(settlementRequestItems.resetAction({actionType:'update'}))
      await dispatch(settlementRequestItems.update({
        url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/settlement-hub/settlement-request-items`, entity: 'productSpecificationAttributeOptions', jsonData: {
          Records: [
            {
              Context: {},
              Records: [{
                ...selectedSettlementRequestItem
              }]
            }
          ]
        }
      }))
    } else {
      await dispatch(settlementRequestItems.resetAction({actionType:'update'}))
      await dispatch(settlementRequestItems.create({
        url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/settlement-hub/settlement-request-items`, entity: 'productSpecificationAttributeOptions', jsonData: {
          Records: [
            {
              Context: {},
              Records: [{
                ...selectedSettlementRequestItem
              }]
            }
          ]
        }
      }))
    }
    closeModal();
    listSettlementRequestItems();
  }

  const closeModal = () => {
    setShowSettlementItemPopup(false)
  }

  useEffect(() => {
    console.log('listOfSettlementRequestItemsData', listOfSettlementRequestItemsData)
    // if(listOfSettlementRequestItemsData?.isSuccess){
      if(listOfSettlementRequestItemsData?.result?.items && listOfSettlementRequestItemsData?.result?.items?.length > 0)
      {
        console.log('listOfSettlementRequestItemsData?.result?.items[0].Error', listOfSettlementRequestItemsData?.result?.items[0].Error)
        if (listOfSettlementRequestItemsData?.result?.items[0].Error){
          setListItems(orderData)          
        }   
        else {
          setListItems(listOfSettlementRequestItemsData?.result?.items)
        }     
      }  else {
        console.log('orderData', orderData)
        setListItems(orderData)
      }    
    // }
  }, [listOfSettlementRequestItemsData]);

  // useEffect(() => {
  //   setListItems(orderData)
  // }, []);

  useEffect(() => {
    console.log('list items', listItems)
  
  }, [listItems]);

  useEffect(() => {
    listSettlementRequestItems();
  }, [deleteSettlementsRequestItemData]);

  useEffect(() => {
    createColumnDefs()
    listSettlementRequestItems()
  }, [pageData, pageSize])

  return (
    <>
      {
        showSettlementItemPopup ?
          <SettlementRequestItemPopup
            // selectedParticipant={selectedParticipant}
            selectedSettlementRequestItem={selectedSettlementRequestItem}
            closeModal={closeModal}
            handleSaveSettlementRequestItem={handleSaveSettlementRequestItem}
            handleInnerFormChange={handleInnerFormChange}
          /> : <></>
      }

      {listOfSettlementRequestItemsData?.isLoading || 
      createSettlementRequestItemsData?.isLoading || 
      editSettlementRequestItemsData?.isLoading || 
      deleteSettlementsRequestItemData?.isLoading ? <PageLoader /> :
        <Table
          columnData={columnDefs}
          enableFilter={true}
          rowData={listItems}
          setPageData={setPageData}
          setPageSize={setPageSize}
          paginationData={listOfSettlementRequestItemsData?.result?.pagination}
          onEdit={handleEdit}
          onDelete={handleDelete}
          additionButtons={additionButtons}
          checkboxConfig={{
            allowMultiSelect: true,
            defaultSelectedIds: [],
            isDisabled: false,
            keyColumn: 'Id',
          }}          
          headingName="Settlement Request Items" />
      }
    </>
  );
};

export default SettlementRequestItems;


